'use strict';

/* eslint no-undef: "off" */
/**
 * XPark service highlights
 */
define('xparkServiceHighlights',['xparkHomepageApi', 'appStorage'], function (xparkHomepageApi, appStorage) {
  return {
    template: '\n      <section class="xp-service-highlights" aria-label="XPark service highlights" v-if="highlights.length">\n        <div\n          v-for="item in highlights"\n          :key="item.title"\n          class="xp-service-highlight-item"\n        >\n          <img :src="item.icon" :alt="item.title" />\n          <h3 v-text="item.title"></h3>\n          <p v-text="item.description"></p>\n        </div>\n        <div class="skeleton-loading" v-if="loading"></div>\n      </section>\n    ',
    data: function data() {
      return {
        loading: false,
        highlights: []
      };
    },
    created: function created() {
      var data = appStorage.get("highlights");
      if (data) {
        this.highlights = JSON.parse(data);
      }
    },
    mounted: function mounted() {
      this.fetchServicePromise();
    },

    methods: {
      fetchServicePromise: function fetchServicePromise() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getServicePromise().then(function (data) {
          if (!Array.isArray(data) || !data.length) {
            return;
          }

          _this.highlights = data.map(function (item) {
            return {
              title: item.title || '',
              description: item.content || item.description || '',
              icon: item.icon || ''
            };
          }).filter(function (item) {
            return item.title && item.icon;
          });
          _this.$nextTick(function () {
            appStorage.set("highlights", JSON.stringify(_this.highlights));
          });
        }).catch(function () {}).finally(function () {
          _this.loading = false;
        });
      }
    }
  };
});
